// import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { ThreeDots } from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import { Button } from '@material-ui/core';


const ActivateTV4Play = async () => {

  //   fetch(apiEndpoint,{headers:{Authorization: '2D6AC8CF-7D30-4963-B429-09459CA23D81'}})
  //       .then(response => response.text())
  //       .then(data => window.location.href =data);

  window.location.href = "https://www.tv4play.se/aktivera-operator";

}

function TV4PlayActivate(props) {

  useEffect(() => {
    setTimeout(() => {
      ActivateTV4Play();
    }, 2000);
  });

  return (
    <div className="container">

      <header className="App-header">
        <img src={require('./images/Sappa_Green.png')} />

        {/* <div style={{backgroundColor: 'red', color:'white', margin:'30px' }}>Just nu är det problem hos TV4 Play att aktivera abonnemang!</div> */}
        <p>
          Startar aktiveringsprocess av TV4 Play...
        </p>
        <ThreeDots color="#000000" height={150} width={150} />
        <img src={require('./images/tv4play.jpg')} />
      </header>

    </div>
  );
}

export default TV4PlayActivate;
